/**
 * Global navigation helper for use outside React component context
 * (e.g., Axios interceptors, service workers).
 *
 * Call `setGlobalNavigate` once from inside the Router to register
 * the React Router navigate function.
 */

type NavigateFn = (to: string, options?: { replace?: boolean }) => void;

let navigateFn: NavigateFn | null = null;

export function setGlobalNavigate(fn: NavigateFn) {
  navigateFn = fn;
}

export function globalNavigate(to: string, options?: { replace?: boolean }) {
  if (navigateFn) {
    navigateFn(to, options);
  } else {
    // Fallback if called before Router mounts (shouldn't happen in practice)
    window.location.href = to;
  }
}
